import { render, staticRenderFns } from "./FeedbackRemark.vue?vue&type=template&id=2759b1ae&scoped=true"
import script from "./FeedbackRemark.vue?vue&type=script&lang=js"
export * from "./FeedbackRemark.vue?vue&type=script&lang=js"
import style0 from "../../../statistics/css/common.css?vue&type=style&index=0&id=2759b1ae&prod&scoped=true&lang=css&external"
import style1 from "./FeedbackRemark.vue?vue&type=style&index=1&id=2759b1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2759b1ae",
  null
  
)

export default component.exports